/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { QuoteRequest } from './';
import {
    QuoteRequestFromJSON,
    QuoteRequestFromJSONTyped,
    QuoteRequestToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';
import type { TimeAndMaterialsQuoteDetailsRequest } from './';
import {
    TimeAndMaterialsQuoteDetailsRequestFromJSON,
    TimeAndMaterialsQuoteDetailsRequestFromJSONTyped,
    TimeAndMaterialsQuoteDetailsRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsQuoteRequest
 */
export interface TimeAndMaterialsQuoteRequest extends QuoteRequest {
    /**
     * 
     * @type {TimeAndMaterialsQuoteDetailsRequest}
     * @memberof TimeAndMaterialsQuoteRequest
     */
    details: TimeAndMaterialsQuoteDetailsRequest;
}

/**
 * Check if a given object implements the TimeAndMaterialsQuoteRequest interface.
 */
export function instanceOfTimeAndMaterialsQuoteRequest(value: object): value is TimeAndMaterialsQuoteRequest {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function TimeAndMaterialsQuoteRequestFromJSON(json: any): TimeAndMaterialsQuoteRequest {
    return TimeAndMaterialsQuoteRequestFromJSONTyped(json, false);
}

export function TimeAndMaterialsQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsQuoteRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteRequestFromJSONTyped(json, ignoreDiscriminator),
        'details': TimeAndMaterialsQuoteDetailsRequestFromJSON(json['details']),
    };
}

export function TimeAndMaterialsQuoteRequestToJSON(value?: TimeAndMaterialsQuoteRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteRequestToJSON(value, true),
        'details': TimeAndMaterialsQuoteDetailsRequestToJSON(value['details']),
    };
}

